

import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"


const Freebies = () => {
  const data = useStaticQuery(graphql`
    query freebiesQuery {
      site {
        siteMetadata {
          title
        }
      }
      allMarkdownRemark(
        sort: { fields: [frontmatter___date], order: DESC }
        filter: { frontmatter: { category: { eq: "FREEBIES" } } }
      ) {
        edges {
          node {
            excerpt(format: HTML)
            html
            frontmatter {
              date(formatString: "MMMM DD, YYYY")
              title
              author
              
              category
              path
              path2
              png{
                childImageSharp {
                  fluid {
                    src
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const illlus = data.allMarkdownRemark.edges

  return (
    <section className="illus freebies">
      <div className="container">
      <div className="title">
          <h1>Freebies</h1>
        </div>
        <div className="illus-wrap">
        {illlus.map(({ node }) => {
          return (
            <div className="day-box">
              <div className="i-wrap">

                <div className="img">
                  <img src={node.frontmatter.png.childImageSharp.fluid.src}/>
                </div>

                <div className="info">
                  <div className="btns">
                  <h5><Link  to={node.frontmatter.path} download className="btn-svg" >{node.frontmatter.title} </Link></h5>

                  </div>
                </div>
              </div>
              <h5><Link download className="btn-svg" to={node.frontmatter.path}>{node.frontmatter.title}</Link></h5>
            </div>
          )
          })}
          </div>
          
      </div>
    </section>
  )
}

export default Freebies
